(function () {

    'use strict';

    angular.module('iplusjs.utils.button', [
        'lodash',
        'iplusjs.utils.format'
    ])
    .service('ButtonUtilsService', ButtonUtilsService);

    ButtonUtilsService.$inject = [
        'lodash',
        'FormatUtilsService'
    ];
    function ButtonUtilsService(_, FormatUtilsService) {
        var that = this;

        that.getButtonCls = getButtonCls;
        function getButtonCls(buttonTemplate, cls) {
            var defaultCls = {
                btn: 'button round',
                link: 'link'
            };

            return (_.union((FormatUtilsService.append(defaultCls[buttonTemplate], cls, ' ')).split(' ')) || []).join(' ');
        }
    }

})();
